// extracted by mini-css-extract-plugin
export default {"container":"_5evYM1","wrapper":"lKZsOe","svg":"Pe64FY","svgAnimation":"MMcPvR","rotate":"vGKEEw","svgCircle":"bLhzTy","svgCircleWithSpin":"Q9cyH2","motion":"YzCdb8"};